import {routerReducer}  from 'react-router-redux'
import { combineReducers } from 'redux';
import {categories} from "./categories";
import {clientOverview} from "./clientOverview";
import {clients} from "./clients";
import {discounts} from "./discounts";
import {generalReducer} from "./generalReducer";
import {login} from "./login";
import {offers} from "./offers";
import {orderForm} from "./orderForm";
import {orderOverview} from "./orderOverview";
import {orders} from "./orders";
import {pointsForm} from "./pointsForm";
import {pointsOverview} from "./pointsOverview";
import {products} from "./products";
import {stores} from "./stores";
import {tellers} from "./tellers";
import {clientForm} from "./clientForm";
import {tellerOverview} from "./tellerOverview";
import {people} from "./people";
import {LOG_OFF} from "../actions";
import storage from "redux-persist/es/storage";
import {enabledOffers} from "./enabledOffers";
import { reducer as form } from 'redux-form/immutable';
import {statistics} from "./statistics";
import {editor} from "./editor";
import {editors} from "./editors";
import {brands} from "./brands";
import {relatedProducts} from "./relatedProducts";
import {productLabels} from "./productLabels";
import {operatorGroups} from "./operatorGroups";
import {campaigns} from "./campaigns";
import {specialOffers} from "./specialOffers";
import {pdfs} from "./pdfs";

const appReducers = combineReducers({
    brands,
    editors,
    editor,
    statistics,
    form,
    enabledOffers,
    people,
    tellerOverview,
    clientForm,
    orderForm,
    pointsOverview,
    pointsForm,
    tellers,
    orderOverview,
    orders,
    clientOverview,
    clients,
    discounts,
    products,
    offers,
    stores,
    login,
    generalReducer,
    router: routerReducer,
    categories,
    relatedProducts,
    productLabels,
    operatorGroups,
    campaigns,
    specialOffers,
    pdfs,
});

export function createReducer(initialState, handlers) {
    return function reducer(state = initialState, action) {
        if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
            return handlers[action.type](state, action);
        }
        return state;
    };
}

const RootReducer = (state, action) => {
    if (action.type === LOG_OFF) {
        Object.keys(state).forEach(key => {
            storage.removeItem(`persist:${key}`);
        });
        state = undefined;
    }
    return appReducers(state, action);
};

export default RootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js